/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { CustomField } from "api/custom-field";
import { LoaderState, INITIAL_LOADER_STATE } from "behaviors/loader/state";

export interface PartialAppState {
  customFields: State;
}

export interface State {
  customFields: Array<CustomField>;
  app: {
    customFieldToBeDeleted: CustomField | null;
  };
  ui: {
    main: LoaderState;
    save: LoaderState | null;
    delete: LoaderState | null;
  };
}

export const INITIAL_STATE: State = {
  customFields: [],
  app: {
    customFieldToBeDeleted: null
  },
  ui: {
    main: INITIAL_LOADER_STATE,
    save: null,
    delete: null
  }
};
